import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal } from "@aureskonnect/react-ui";

import { AlertModalHeader } from "./ConfirmationActiveFidelityParts/AlertModalHeader";
import { AlertMessage } from "./ConfirmationActiveFidelityParts/AlertMessage";
import { CloseFooter } from "./ConfirmationActiveFidelityParts/CloseFooter";

type ConfirmationActiveMessageType = {
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    isModalOpened: boolean;
};

export function ConfirmationActiveFidelity({
    setIsModalOpened,
    isModalOpened,
}: ConfirmationActiveMessageType) {
    const { t } = useTranslation();
    const close = () => setIsModalOpened(!isModalOpened);

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <AlertModalHeader title={t("Alert")} onClose={close} />
            <AlertMessage
                message={t(
                    "Attention ! The fidelity settings is archived at one or more stores. The fidelity settings will be unarchive only at the franchise level."
                )}
            />
            <CloseFooter label={t("Close")} onClose={close} />
        </StyledModal>
    );
}
